export enum PopupType {
  confirmationPopup = "confirmationPopup",
  errorPopup = "errorPopup" ,
  selectUserPopup ="selectUserPopup",
  infoTable = "infoTable",
  successPopup = "successPopup"
}
